// extracted by mini-css-extract-plugin
export default {"fullscreen":"n4eV5cGy","desktop":"desktop","mobile":"mobile","image":"MQtEEkHZ","caption":"Fm_KGIim","captionHidden":"lAcrE29R","icon":"TYePTTcw"};